import $ from 'jquery';

function sortMe() {
    $('.sortable').sort(function (lhs, rhs) {
        var a = $(lhs).attr("data-order").toLowerCase()
        var b = $(rhs).attr("data-order").toLowerCase()
        return a > b ? 1 : a == b ? 0 : -1
    }).appendTo($('.sortable').parent())
    $('.sortable, #ing-search-filter-bar, .ingredients__table-row__top').fadeTo('slow', 1.00)
}

function noResults() {
    $('.ingredients__table-row__contents:visible').length < 1 ? $("#no-results").show() : $("#no-results").hide()
}

function filterMe() {
    var scent = $("select[name='ing-filter']").val();
    var search = $("#filter").val();
    $(".ingredients__table-row__contents").hide();
    var boxes = $(".ingredients__table-row__contents").filter(function (index) {

        return (scent === 'All' || $(this).text().toLowerCase().indexOf(scent.toLowerCase()) >= 0) &&
            (!search || $(this).text().toLowerCase().indexOf(search.toLowerCase()) >= 0);
    })
    boxes.show()
}

$(function () {

    $("select[name='ing-filter']").change(function () {
        filterMe()
        noResults()
    });
    $("#filter").keyup(function () {
        filterMe()
        noResults()
        if ($(this).val()) {
            $("#ing-search-holder .close-x-btn").show();
        } else {
            $("#ing-search-holder .close-x-btn").hide();
        }
    })

    /* Clear */
    $("#ing-search-holder .close-x-btn").click(function () {
        $("#filter").val('');
        $(this).hide();
        $("#no-results").hide();
        $(".sortable .ingredients__table-row__contents").show();
        $("select[name='ing-filter']>option:eq(0)").prop("selected", true);
    });

    /* Add Commas */
    $(".ingredient_product_name a.eyebrow--underline:not(:last-child)").append(",");

    $('#ing__hero').addClass("fade-in")
    sortMe()

})
